<template>
  <div class="item-master-view">
    <div class="item-master-view__tabs">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="item-master-view__tab"
        :class="{ 'is-active': activeTab === tab.id }"
        @click="activeTab = tab.id"
        type="button"
      >
        <img
          class="item-master-view__tab-icon"
          :src="tab.icon"
          :alt="tab.label"
        />
        <span>{{ tab.label }}</span>
      </button>
    </div>

    <div class="item-master-view__content">
      <item-master-details-section
        v-if="activeTab === 'details'"
        :materialMaster="materialMaster"
        :view="view"
      />
      <item-master-tags-documents-section
        v-else-if="activeTab === 'tags'"
        :materialMaster="materialMaster"
      />
      <item-master-active-workflows-section
        v-else-if="activeTab === 'workflows'"
        :materialMaster="materialMaster"
      />
      <item-master-history-section v-else :materialMaster="materialMaster" />
    </div>
  </div>
</template>

<script>
import ItemMasterDetailsSection from './itemMasterViewComponents/ItemMasterDetailsSection.vue'
import ItemMasterTagsDocumentsSection from './itemMasterViewComponents/ItemMasterTagsDocumentsSection.vue'
import ItemMasterHistorySection from './itemMasterViewComponents/ItemMasterHistorySection.vue'
import ItemMasterActiveWorkflowsSection from './itemMasterViewComponents/ItemMasterActiveWorkflowsSection.vue'

export default {
  name: 'ItemMasterDetailView',
  components: {
    ItemMasterDetailsSection,
    ItemMasterTagsDocumentsSection,
    ItemMasterHistorySection,
    ItemMasterActiveWorkflowsSection
  },
  props: {
    materialMaster: {
      type: Object,
      default: () => ({})
    },
    view: {
      type: String,
      default: 'material'
    },
    initialTab: {
      type: String,
      default: 'details'
    }
  },
  data () {
    return {
      activeTab: this.initialTab
    }
  },
  computed: {
    tabs () {
      return [
        {
          id: 'details',
          label: 'Details',
          icon: require('@/assets/images/icons/list-icon.svg')
        },
        {
          id: 'tags',
          label: 'Linked Entities',
          icon: require('@/assets/images/icons/tag-icon.svg')
        },
        {
          id: 'history',
          label: 'History',
          icon: require('@/assets/images/icons/history-icon.svg')
        },
        {
          id: 'workflows',
          label: 'Active Workflows',
          icon: require('@/assets/images/icons/workflow-icon.svg')
        }
      ]
    },
    validTabIds () {
      return this.tabs.map((tab) => tab.id)
    }
  },
  mounted () {
    const queryTab = this.$route?.query?.activeTab
    if (this.validTabIds.includes(queryTab)) {
      this.activeTab = queryTab
    }
    this.syncActiveTabToRoute(this.activeTab)
  },
  methods: {
    syncActiveTabToRoute (tab) {
      if (!this.validTabIds.includes(tab)) return
      if (this.$route?.query?.activeTab === tab) return
      this.$router.replace({
        query: {
          ...this.$route.query,
          activeTab: tab
        }
      }).catch(() => {})
    }
  },
  watch: {
    initialTab (newTab) {
      if (this.validTabIds.includes(newTab)) {
        this.activeTab = newTab
      }
    },
    '$route.query.activeTab' (newTab) {
      if (this.validTabIds.includes(newTab) && this.activeTab !== newTab) {
        this.activeTab = newTab
      }
    },
    activeTab (newTab) {
      this.syncActiveTabToRoute(newTab)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-master-view {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  &__tabs {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    border-bottom: 1px solid #e5e7eb;
    background: #ffffff;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  &__tab {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 10px;
    border: none;
    background: transparent;
    font-weight: 500;
    color: #0f172a;
    cursor: pointer;
    position: relative;
    span {
      font-size: var(--text-xs2)
    }
  }

  &__tab-icon {
    width: 16px;
    height: 16px;
  }

  &__tab.is-active {
    box-shadow: inset 0 -3px 0 #f59e0b;
    background: #fff7ed;
  }

  &__content {
    flex: 1;
    background: #f8fafc;
    min-height: 0;
    display: flex;
  }
}

@media (max-width: 768px) {
  .item-master-view {
    &__tabs {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
</style>
